<template>
    <section ref="swiper" class="pr">
        <div :class="`swiper-box${diff}`" :style="style">
            <swiper :options="options">
                <swiper-slide v-if="path" class="swiper-slide df">
                    <router-link v-if="sorts[0].routeName === undefined" :to="path" :class="`sort${id === 0 ? ' router-link-active' : ''}`" exact>{{first}}</router-link>
                    <router-link v-if="sorts[0].routeName !== undefined" :to="path" :class="`sort${$route.name === sorts[0].routeName ? ' router-link-active' : ''}`" exact>{{first}}</router-link>
                </swiper-slide>
                <swiper-slide v-for="(v, k) in sorts" :key="k" class="swiper-slide df">
                    <router-link v-if="v.path === undefined" :to="`${path}?sort=${v.id}`" :class="`sort${id === v.id ? ' router-link-active' : ''}`" exact>{{v.name}}</router-link>
                    <router-link v-if="v.path !== undefined" :to="v.path" :class="`sort${$route.name === v.routeName ? ' router-link-active' : ''}`" exact>{{v.name}}</router-link>
                </swiper-slide>
            </swiper>
        </div>
        <div class="nav-empty"></div>
    </section>
</template>

<script>
    export default {
        props: {
            sorts: Array,
            path: String,
            first: {
                type: String,
                default: '全部',
            },
        },
        data: () => ({
            options: {
                slidesPerView: 'auto',
                freeMode: true,
                freeModeSticky : true,
            },
            y: 0,
            diff: '',
            has_timer: false,
            offsetTop: 0,
            top: 0,
            style: 'position: absolute;top:0',
        }),
        computed: {
            id() {
                return +this.$route.query.sort || 0;
            },
        },
        methods: {
            scroll() {// diff < 0 Scroll down
                const y = window.pageYOffset;
                this.style =  y > this.top ? 'position:fixed;top:11.8vw' : 'position: absolute;top:0';
                this.diff = y - this.y > 0 && y > this.offsetTop ? ' hidden' : '';
                this.y = y;
            }
        },
        mounted() {
            this.offsetTop = this.$refs.swiper.offsetTop;
            this.top = this.offsetTop - this.$refs.swiper.offsetHeight;
            window.addEventListener('scroll', this.scroll);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.scroll);
        }
    }
</script>

<style scoped>
    @import '../../../static/css/base/nav.css';
</style>


// WEBPACK FOOTER //
// src/components/contest/Nav.vue